import styled from 'styled-components';

import Text from 'components/Text';
import { colors } from 'pages/Quotes/styles/colors';

import { ButtonGridItemProps } from './interface';

export const Container = styled.div`
  width: 679px;
  min-height: calc(100vh - 90px);

  background: #FFFFFF;
  mix-blend-mode: normal;
  box-shadow: 0px 0.25rem 0.25rem rgba(0, 0, 0, 0.25);

  margin: 0 auto;
  padding: 1.25rem 3.125rem;

  input {
    width: 190px;
  }

  input[type=time] {
    padding-right: 0.313rem;
  }

  @media screen and (max-width: 679px) {
    width: 100%;
  }
`;

export const Content = styled.div`
  margin-top: 2.188rem;

  small {
    display: block;

    font: 400 italic 0.75rem/1.3 "Lato", serif;
    text-align: right;
  }
`;

export const FormSchedule = styled.form`
  margin-top: 1.563rem;

  button {
    margin: 1.875rem auto 1.875rem auto;
  }

  textarea {
    flex: 1;
    height: 140px;
    min-height: 140px;
  }
`;

export const AppointmentDate = styled.div`
  margin-right: 1.25rem
`;

export const Title = styled(Text).attrs({
  className: "color-primary font-bold",
  size: 24
})`
  line-height: 1.813rem;
  letter-spacing: -0.015em;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  min-height: 95px;

  border-top: 1px solid rgb(211, 211, 211);
  background: #fff;
`;

export const TableGrid = styled.div`
  display: flex;
  grid-template-columns: repeat(10, auto);
  border: 2px solid #CBCBCB;
  flex-direction: column;
`;

export const TableRow = styled.div`
  display: flex;
`;

export const ButtonGridItem = styled.button<ButtonGridItemProps>`
  background: ${(props: any) => props.isActive() ? `${colors.yellow}` : "rgba(255, 255, 255, 0.8)"};
  border: 1px solid #CBCBCB;
  text-align: center;

  height: 50px;
  width: 55px;

  font-size: 14px;
  line-height: 22px;
  color: ${(props: any) => props.isActive() ? `${colors.white}` : `${colors.blueDark}`};
  
  display: flex;
  justify-content: center;
  align-items: center;

  ${props => {
    return `font-weight: ${props?.isActive && props?.isActive() ? "600" : "normal"}`;
  }}
`;

export const TableGridDate = styled.div`
  position: relative;
  background-color: rgba(255, 255, 255, 0.8);
  border: 1px solid #CBCBCB;
  text-align: center;

  height: 50px;
  width: 80px;

  font-size: 14px;
  line-height: 22px;
  color: #0e4c54;

  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;

  small {
    font: 400 normal 0.688rem/2.2 "Lato", serif;
    top: 5px;
    position: absolute;
  }

  > p {
    font: 800 normal 0.875rem/2.2 "Lato", serif;
  }
`;